import { Modal } from "antd";
import Avatar from "antd/es/avatar/Avatar";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { getEmployees } from "../../../core/data/redux/employeesSlice";
import styles from "./WhoIsWho.module.css";

const WhoIsWho: React.FC = () => {
  const initSearchCriteria = {
    firstname: "",
    lsastname: "",
    empId: "",
    email: "",
    phone: "",
    wing: "",
    department: "",
    designation: "",
  };
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState(initSearchCriteria);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [hasSearched, setHasSearched] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const employeesState = useSelector((state: any) => state.employeesState);
  
  // Debug logging
  console.log('employeesState:', employeesState);
  console.log('employeesState.data:', employeesState?.data);
  console.log('employeesState.data.data:', employeesState?.data?.data);
  console.log('employeesState.data.data.data:', employeesState?.data?.data?.data);
  
  const employees = Array.isArray(employeesState?.data?.data?.data?.data) 
    ? employeesState.data.data.data.data 
    : Array.isArray(employeesState?.data?.data?.data) 
      ? employeesState.data.data.data 
      : [];
  
  console.log('employees array:', employees);
  console.log('employees length:', employees.length);
  
  const totalRecords = employeesState?.data?.data?.data?.total 
    || employeesState?.data?.data?.total 
    || 0;
    
  const totalPages = employeesState?.data?.data?.data?.totalPages 
    || employeesState?.data?.data?.totalPages 
    || 0;
  const dispatch = useDispatch();
  const randomAvatar = (firstName: string) => {
    const colors = [
      "#f56a00",
      "#7265e6",
      "#ffbf00",
      "#00a2ae",
      "#87d068",
      "#d46b08",
    ];
    const index = Math.floor(Math.random() * colors.length);
    const initial = firstName?.charAt(0)?.toUpperCase() || "?";
    return {
      bg: colors[index],
      initial,
    };
  };
  const openModal = (employee: any) => {
    setSelectedEmployee(employee);
    setModalVisible(true);
  };
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index +
                pagination.current * pagination.pageSize -
                pagination.pageSize +
                1
              : index + 1}
          </div>
        </>
      ),
    },
    {
      title: "Name",
      dataIndex: "details",
      render: (details: any, record: any) => {
        const first = details?.firstname?.trim() || "";
        const last =
          details?.lsastname?.trim() || details?.lastname?.trim() || "";

        if (!first && !last) return <div style={{ height: "40px" }}></div>;

        const avatarInfo = randomAvatar(first);

        return (
          <span
            onClick={() => openModal(record)}
            className="d-flex align-items-center text-decoration-none"
            style={{ color: "inherit", cursor: "pointer" }}
          >
            {details?.image ? (
              <Avatar
                src={`data:image/jpeg;base64,${details.image}`}
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              />
            ) : (
              <Avatar
                className="me-2"
                style={{
                  backgroundColor: avatarInfo.bg,
                  verticalAlign: "middle",
                  width: "50px",
                  height: "50px",
                }}
              >
                {avatarInfo.initial}
              </Avatar>
            )}
            <div className="text-primary">{`${first} ${last}`.trim()}</div>
          </span>
        );
      },
    },
    {
      title: "Emp Id",
      dataIndex: "empId",
      sorter: (a: any, b: any) => parseInt(a.empId) - parseInt(b.empId),
      render: (empId: string) => parseInt(empId, 10),
    },
    {
      title: "Email",
      dataIndex: "details",
      render: (details: any) => details?.email || "-",
    },
    {
      title: "Phone",
      dataIndex: "details",
      render: (details: any) => details?.phone || "-",
    },
    {
      title: "Date of Birth",
      dataIndex: "details",
      render: (details: any) =>
        details?.birthdate
          ? moment(details.birthdate).format("DD-MM-YYYY")
          : "-",
    },
    {
      title: "Joining Date",
      dataIndex: "details",
      render: (details: any) =>
        details?.date_of_joining
          ? moment(details.date_of_joining).format("DD-MM-YYYY")
          : "-",
    },
    {
      title: "Wing",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.wing_name || "-",
    },
    {
      title: "Department",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.department_name || "-",
    },
    {
      title: "Designation",
      dataIndex: "details",
      render: (details: any) =>
        details?.sap_department_designation_wings?.designation_name || "-",
    },
    {
      title: "Reporting Manager",
      dataIndex: "details",
      render: (details: any) => {
        if (!details?.reportingManagerID) return "-";
        
        const managerId = parseInt(details.reportingManagerID, 10);
        const managerName = details?.reportingManagerName || details?.manager?.firstname 
          ? `${details.manager?.firstname || ''} ${details.manager?.lsastname || ''}`.trim()
          : '';
        
        if (managerName) {
          return `${managerId} - ${managerName}`;
        }
        return managerId;
      },
    },
    {
      title: "Role",
      dataIndex: "hrms_role",
      render: (hrms_role: any) => hrms_role?.role?.role_name || "",
    },
  ];

  const handleInputChange = (field: string, value: string) => {
    setSearchCriteria((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const fetchRecords = (pagination: any, filters: any) => {
    setHasSearched(true);
    dispatch(
      getEmployees({
        page: pagination.current,
        limit: pagination.pageSize,
        filters: filters,
      })
    );
  };
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      fetchRecords(pagination, searchCriteria);
    }
  };
  const resetSearch = () => {
    setSearchCriteria(initSearchCriteria);
    setHasSearched(false);
  };
  const handlePagination = (paginationData: any) => {
    setPagination({
      current: paginationData.page || paginationData.current,
      pageSize: paginationData.pageSize,
      total: totalRecords,
    });
  };

  return (
    <React.Fragment>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Other Services</li>
                  <li className="breadcrumb-item active">Who is Who</li>
                </ul>
              </div>
            </div>
          </div>
          {/* Search Section */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">
                    Who is Who - Employee Directory Search
                  </h4>
                  <button
                    type="button"
                    className="btn btn-outline-info btn-sm"
                    onClick={() => setShowAdvancedSearch(!showAdvancedSearch)}
                  >
                    <i
                      className={`ti ${
                        showAdvancedSearch ? "ti-chevron-up" : "ti-chevron-down"
                      } me-1`}
                    />
                    {showAdvancedSearch ? "Hide" : "Show"} Advanced Search
                  </button>
                </div>
                <div className="card-body">
                  {/* Main Search - Only First Name and Last Name */}
                  <div className="row row-gap-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter first name"
                          value={searchCriteria.firstname}
                          onChange={(e) =>
                            handleInputChange("firstname", e.target.value)
                          }
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter last name"
                          value={searchCriteria.lsastname}
                          onChange={(e) =>
                            handleInputChange("lsastname", e.target.value)
                          }
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                    </div>
                    {showAdvancedSearch && (
                      <React.Fragment>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter employee ID"
                              value={searchCriteria.empId}
                              onChange={(e) =>
                                handleInputChange("empId", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Email"
                              value={searchCriteria.email}
                              onChange={(e) =>
                                handleInputChange("email", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter phone"
                              value={searchCriteria.phone}
                              onChange={(e) =>
                                handleInputChange("phone", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Wing"
                              value={searchCriteria.wing}
                              onChange={(e) =>
                                handleInputChange("wing", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Department"
                              value={searchCriteria.department}
                              onChange={(e) =>
                                handleInputChange("department", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Designation"
                              value={searchCriteria.designation}
                              onChange={(e) =>
                                handleInputChange("designation", e.target.value)
                              }
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    <div className="col-md-4 d-flex align-items-end">
                      <div className="d-flex gap-2 w-100">
                        <button
                          type="button"
                          className="btn btn-primary flex-grow-1"
                          onClick={() =>
                            fetchRecords(pagination, searchCriteria)
                          }
                          disabled={employeesState.loading === "pending"}
                        >
                          {employeesState.loading === "pending" ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></span>
                              Searching...
                            </>
                          ) : (
                            <>
                              <i className="ti ti-search me-1"></i>Search
                              Employees
                            </>
                          )}
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={resetSearch}
                          disabled={employeesState.loading === "pending"}
                        >
                          <i className="ti ti-refresh me-1"></i>Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Results Section - List/Table Format */}
          {hasSearched && (
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title">
                      Search Results ({totalRecords} Employee
                      {totalRecords !== 1 ? "s" : ""} Found)
                    </h5>
                  </div>
                  <div className="card-body p-0 py-3">
                    {employeesState.loading === "pending" ? (
                      <div className="text-center py-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Searching employees...</p>
                      </div>
                    ) : employees.length === 0 ? (
                      <div className="text-center py-5">
                        <i
                          className="ti ti-users-off"
                          style={{ fontSize: "3rem", color: "#ccc" }}
                        ></i>
                        <p className="text-muted mt-3">
                          No employees found matching your search criteria.
                        </p>
                        <p className="text-muted">
                          Try adjusting your search terms or use fewer filters.
                        </p>
                      </div>
                    ) : (
                      <Table
                        columns={columns}
                        dataSource={employees}
                        Selection={false}
                        paginationConfig={{
                          ...pagination,
                          total: totalRecords
                        }}
                        handlePagination={handlePagination}
                        loading={false}
                        handleSearch={() => {}} // Search is handled by the form above
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        title={null}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={380}
        className="employee-modal"
        closable={true}
      >
        {selectedEmployee && (
          <div className={styles['employee-modal-content']}>
            {/* Profile Picture */}
            <div className={styles['employee-avatar-container']}>
              {selectedEmployee.details?.image ? (
                <img
                  src={`data:image/jpeg;base64,${selectedEmployee.details.image}`}
                  alt="Profile"
                  className={styles['employee-avatar']}
                />
              ) : (
                <div className={`${styles['employee-avatar']} ${styles['employee-avatar-placeholder']}`}>
                  {selectedEmployee.details?.firstname?.charAt(0)?.toUpperCase() || "?"}
                </div>
              )}
            </div>

            {/* Employee Details */}
            <div className={styles['employee-details-grid']}>
              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Name</div>
                <div className={styles['detail-value']}>
                  {`${selectedEmployee.details?.firstname || ""} ${
                    selectedEmployee.details?.lastname || selectedEmployee.details?.lsastname || ""
                  }`.trim() || "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Date of Birth</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.birthdate
                    ? moment(selectedEmployee.details.birthdate).format("DD-MM-YYYY")
                    : "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Marital Status</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.marital_status || "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Email Address</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.email || "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Blood Group</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.blood_group || "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Designation</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.sap_department_designation_wings?.designation_name ||
                    selectedEmployee.details?.designation?.designation_name ||
                    selectedEmployee.designation ||
                    "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Department</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.sap_department_designation_wings?.department_name ||
                    selectedEmployee.details?.department?.department_name ||
                    selectedEmployee.department ||
                    "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Wing</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.wing || "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Joining Date</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.date_of_joining
                    ? moment(selectedEmployee.details.date_of_joining).format("DD-MM-YYYY")
                    : "N/A"}
                </div>
              </div>

              <div className={styles['detail-row']}>
                <div className={styles['detail-label']}>Contact No</div>
                <div className={styles['detail-value']}>
                  {selectedEmployee.details?.phone || "N/A"}
                </div>
              </div>
            </div>

            {selectedEmployee.emergency_contacts && selectedEmployee.emergency_contacts.length > 0 && (
              <div className="mt-3 pt-3 border-top">
                <h6 className="fw-bold mb-2">Emergency Contact Details</h6>
                {selectedEmployee.emergency_contacts.map((contact: any, idx: number) => (
                  <div key={idx} className="small mb-2 p-2 bg-light rounded">
                    <div><strong>Name:</strong> {contact.name || "N/A"}</div>
                    <div><strong>Relation:</strong> {contact.relation || "N/A"}</div>
                    <div><strong>Phone:</strong> {contact.phone || "N/A"}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Modal>
    </React.Fragment>
  );
};

export default WhoIsWho;
